export const ExpenseColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "date",
    title: "Date",
  },
  {
    id: "type",
    title: "Expense Type",
  },
  {
    id: "accountId",
    title: "Account",
  },
  {
    id: "desc",
    title: "Description",
  },
  {
    id: "expense",
    title: "Expense",
  },
];
